import axios, { AxiosInstance } from 'axios';
import * as clone from 'clone';

export default (host: string, end: string = '', version: string = ''): AxiosInstance => {
  const ins = axios.create({
    baseURL: [host, end, version].filter(v => !!v).join('/'),
  });
  ins.interceptors.request.use(request => {
    request.headers.Authorization = `Bearer ${localStorage.getItem('mg.token')}`;
    if (request.params) {
      request.params = clone(request.params);
      Object.keys(request.params).forEach(key => {
        if (typeof request.params[key] === 'object') {
          request.params[key] = JSON.stringify(request.params[key]);
        }
      });
    }
    return request;
  });
  ins.interceptors.response.use(response => {
    return response;
  }, error => {
    let errorMessage;
    // if (error.response && error.response.data.redirect) {
    //   window.location.href = error.response.data.redirect;
    // }
    errorMessage = error.response ? error.response.data.error : error.message;
    return Promise.reject(errorMessage || 'User abort');
  });

  return ins;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/_createAPI.ts